import { AbstractLocalDataAccessLayer } from "@/lib/utility/data/local-data-access-layer.abstract";
import { IVehicle, Vehicle } from "@/models/vehicle.entity";

export const FleetVehicleDataAccessLayer = new (class extends AbstractLocalDataAccessLayer<IVehicle> {
  protected mapEntity(entity: IVehicle): IVehicle {
    return new Vehicle(entity);
  }

  getIdentifier(entity: IVehicle): string {
    return entity.id;
  }
})();
